/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Redirect({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}><g stroke="currentColor" strokeWidth={1.2} clipPath="url(#Redirect_svg__clip0_2750_1148)"><path strokeLinecap="round" d="m8.706 1.14-.022 13.72" /><path strokeLinejoin="round" d="M8.706 2.484h4.626a.5.5 0 0 1 .317.114l1.675 1.375a.5.5 0 0 1 0 .773L13.648 6.12a.5.5 0 0 1-.317.113H8.706m-.412 4.877H3.67a.5.5 0 0 1-.318-.114L1.677 9.62a.5.5 0 0 1 0-.773L3.35 7.473a.5.5 0 0 1 .318-.114h4.625" /></g></svg>;
}
;